import { render, staticRenderFns } from "./result-success.vue?vue&type=template&id=06647e46&scoped=true&lang=html&"
import script from "./result-success.vue?vue&type=script&lang=js&"
export * from "./result-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06647e46",
  null
  
)

export default component.exports